/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Auto_ConvertInputs */

const cs_sklik_auto_convert = /** @type {(inputs: Sklik_Auto_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat SEM konverzi při leadu ze Skliku`)
};

const en_sklik_auto_convert = /** @type {(inputs: Sklik_Auto_ConvertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send SEM conversion when a Sklik-attributed lead arrives`)
};

/**
* | output |
* | --- |
* | "Send SEM conversion when a Sklik-attributed lead arrives" |
*
* @param {Sklik_Auto_ConvertInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_auto_convert = /** @type {((inputs?: Sklik_Auto_ConvertInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Auto_ConvertInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_auto_convert(inputs)
	return cs_sklik_auto_convert(inputs)
});